import { AdminRoutes } from './admin_routes';
import AppPage from '../App';
import BookingPage from '../pages/booking';
import { createBrowserRouter } from 'react-router';
import CustomerLogin from '../pages/auth/customer_login';
import CustomerSignUp from '../pages/auth/customer_signup';
import EmbeddedForm from '../pages/form';
import ErrorBoundary from '../components/error_boundary';
import ForgetPasswordPage from '../pages/auth/forget_password';
import LandingPage from '../pages/landing';
import LoginPage from '../pages/auth/login';
import PrivacyPolicy from '../pages/privacy';
import ResetPasswordPage from '../pages/auth/reset';
import SignUpPage from '../pages/auth/signup';
import TermsPage from '../pages/term';
import ToastLayout from '../pages/toast_layout';

export const liveRoutes = createBrowserRouter([
    {
        path: '/',
        Component: () => <LandingPage />
    },
    {
        path: '/term',
        Component: () => <TermsPage />
    },
    {
        path: '/privacy',
        Component: () => <PrivacyPolicy />
    },
    {
        path: '/login',
        Component: () => <ErrorBoundary><LoginPage /></ErrorBoundary>
    },
    {
        path: '/signup',
        Component: () => <ErrorBoundary><SignUpPage /></ErrorBoundary>
    },
    {
        path: '/app',
        element: <ErrorBoundary><AppPage /></ErrorBoundary>,
        children: AdminRoutes
    },
    {
        path: '/customer-login',
        Component: () => <ErrorBoundary><CustomerLogin /></ErrorBoundary>
    },
    {
        path: '/forget-password',
        Component: () => <ErrorBoundary><ForgetPasswordPage /></ErrorBoundary>
    },
    {
        path: '/signup/:code',
        Component: () => <ErrorBoundary><CustomerSignUp /></ErrorBoundary>
    },
    {
        path: '/forms/:code',
        element: <ErrorBoundary><ToastLayout><EmbeddedForm /></ToastLayout></ErrorBoundary>
    },
    {
        path: '/reset-password/:code',
        element: <ErrorBoundary><ResetPasswordPage /></ErrorBoundary>
    },
    {
        path: '/booking/:eventId',
        Component: () => <ErrorBoundary><BookingPage /></ErrorBoundary>
    },
    {
        path: '*',
        Component: () => <ErrorBoundary><LoginPage /></ErrorBoundary>
    }
]);